import DatabaseModel from './DatabaseModel.js';

var UsuarioCliente = Object.create(DatabaseModel);

UsuarioCliente.model = 'usuariocliente';

UsuarioCliente.me = function() {
    var self = this;
    return new Promise(function(resolve, reject) {
        self.request.promise({
            url: self.server_contabilidad + self.prefix + self.model + '/me/',
            method: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            crossDomain: true,
            data: {}
        }).then(function({ data, xhr, status }) {
            if (data.error) {
                reject(data);
            } else {
                resolve(data.dto);
            }
        }).catch(function({ xhr, status, message }) {
            try {
                reject(JSON.parse(xhr.response).error);
            } catch (e) {
                reject(xhr.response);
            }
        });
    });
};

export default UsuarioCliente;